import { usePageHeader } from "@/components/layouts/lib/page-header";
import { NotificationDetailDialog } from "./notifications/components/NotificationDetailDialog";
import { NotificationFilterBar } from "./notifications/components/NotificationFilterBar";
import { NotificationInboxSidebar } from "./notifications/components/NotificationInboxSidebar";
import { NotificationKpiGrid } from "./notifications/components/NotificationKpiGrid";
import { NotificationList } from "./notifications/components/NotificationList";
import { NotificationPagination } from "./notifications/components/NotificationPagination";
import { useNotificationActions } from "./notifications/hooks/useNotificationActions";
import { useNotificationInboxData } from "./notifications/hooks/useNotificationInboxData";
import { useNotificationInboxState } from "./notifications/hooks/useNotificationInboxState";

export default function NotificationsPage() {
  usePageHeader({
    title: "Notifications",
    helpTopic: "notifications",
    guide: {
      steps: [
        "Cliquez sur une notification pour ouvrir le document ou l'enregistrement concerné.",
        "Les préférences par événement (in-app/email) se règlent dans Paramètres, pas ici.",
      ],
    },
  });

  const inboxState = useNotificationInboxState();
  const inboxData = useNotificationInboxData(inboxState.filters);
  const actions = useNotificationActions();

  return (
    <div className="space-y-5">
      <NotificationKpiGrid stats={inboxData.stats} total={inboxData.total} />

      <div className="grid gap-4 xl:grid-cols-[220px_minmax(0,1fr)]">
        <NotificationInboxSidebar
          status={inboxState.status}
          unread={inboxData.unread}
          onStatusChange={inboxState.setStatus}
        />

        <section className="min-w-0 rounded-lg border border-border bg-card">
          <NotificationFilterBar
            search={inboxState.search}
            category={inboxState.category}
            severity={inboxState.severity}
            unread={inboxData.unread}
            isFetching={inboxData.isFetching}
            markAllReadMutation={inboxData.markAllReadMutation}
            onSearchChange={inboxState.setSearch}
            onCategoryChange={inboxState.setCategory}
            onSeverityChange={inboxState.setSeverity}
          />

          <NotificationList
            notifications={inboxData.notifications}
            isLoading={inboxData.isLoading}
            dismissingId={actions.dismissMutation.variables}
            dismissing={actions.dismissMutation.isPending}
            onOpen={actions.openNotification}
            onDismiss={(id) => actions.dismissMutation.mutate(id)}
          />

          <NotificationPagination
            total={inboxData.total}
            page={inboxState.page}
            pageCount={inboxData.pageCount}
            onPageChange={inboxState.setPage}
          />
        </section>
      </div>

      <NotificationDetailDialog
        notification={actions.selected}
        onOpenChange={(open) => {
          if (!open) actions.closeDetail();
        }}
        onFollow={actions.followAction}
        onDismiss={actions.dismissFromDetail}
      />
    </div>
  );
}
